import type { Task } from "~skillBuilder/utils/types";

export const TspOverview = {
  name: "Overview",
  uniqueName: "tsp-overview",
  icon: "Overview",
  durationTimeText: "2 min",
  isIntro: true,
  steps: [
    // Step 1
    {
      nextButtonText: "Start Lesson",
      questions: [
        // Question 1.1
        {
          attribute: "the-sub-playbook/overview",
          label: "The Sub Playbook: the Art of Subbing",
          answerType: {
            type: "CONTENT",
            value: "valid",
            markdown: `
<div>
  <p>This comprehensive session equips you with the essential tools to be a successful substitute. We will cover everything from the logistics of the Swing experience and the core of professional reliability to advanced classroom engagement and instructional strategies.</p>
</div>
`,
          },
        },
      ],
    },
  ],
} as const satisfies Task;
